import { dmSans, fraunces } from "@/fonts";
import type { BlockAppearance, CtaButton } from "@/lib/storefront-types";

export const heroDisplayFont = fraunces;
export const heroBodyFont = dmSans;

export type HeroSliderTone = "light" | "dark" | "frozen";

export function resolveHeroSliderTone(
  appearance: BlockAppearance | null | undefined,
): HeroSliderTone {
  if (appearance === "light") {
    return "light";
  }

  if (appearance === "frozen") {
    return "frozen";
  }

  return "dark";
}

const heroSliderGhostButtonStyles: Record<HeroSliderTone, string> = {
  light:
    "border-[rgba(var(--storefront-primary-dark-rgb),0.24)] bg-transparent text-[rgba(var(--storefront-primary-dark-rgb),0.92)] hover:bg-[rgba(var(--storefront-primary-rgb),0.08)] hover:border-[rgba(var(--storefront-primary-dark-rgb),0.38)]",
  dark:
    "border-white/30 bg-transparent text-white/92 hover:border-white/58 hover:bg-white/8",
  frozen:
    "border-white/30 bg-transparent text-white/92 hover:border-white/58 hover:bg-white/10",
};

const navButtonStylesByTone: Record<HeroSliderTone, string> = {
  light: "storefront-text-heading hover:bg-white",
  dark: "text-white hover:bg-white/10",
  frozen: "text-white hover:bg-white/10",
};

export function getHeroSliderCtaClassName(
  tone: HeroSliderTone,
  _style: CtaButton["style"],
) {
  void _style;

  return `${heroBodyFont.className} inline-flex items-center justify-center rounded-full border px-8 py-[0.88rem] text-[0.96rem] font-medium uppercase tracking-[0.14em] transition-[color,border-color,background-color,transform] duration-200 hover:-translate-y-px ${heroSliderGhostButtonStyles[tone]}`;
}

export function getHeroSliderNavButtonClassName(tone: HeroSliderTone) {
  return `${heroBodyFont.className} pointer-events-auto inline-flex h-10 items-center justify-center rounded-full px-4 text-sm font-semibold transition-colors ${navButtonStylesByTone[tone]}`;
}
